import { useIsCreatingResource } from "src/system/useIsCreatingResource.ts";
import { useIsUpdatingResource } from "src/system/useIsUpdatingResource.ts";
import { useIsDeletingResource } from "src/system/useIsDeletingResource.ts";
import { useIsCloningResource } from "src/system/useIsCloningResource.ts";
import { useIsAdditionalFormMutationRunning } from "src/system/useIsAdditionalFormMutationRunning.ts";
import { useResourceFormQuery } from "src/components/Form/hooks/useResourceFormQuery.ts";
import { useResourceFormContext as useFrameworkFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";

export const useIsFormOverlayLoading = () => {
  const { isLoading, isRefetching } = useResourceFormQuery();

  const { resource, action, tab, id, lang: locale } = useFrameworkFormContext();

  const isCreating = useIsCreatingResource({
    resource,
    locale,
  });

  const isUpdating = useIsUpdatingResource({
    resource,
    id: id!,
    locale,
  });
  const isDeleting = useIsDeletingResource({
    resource,
    id: id!,
  });

  const isCopying = useIsCloningResource({
    resource,
    id: id!,
  });

  const isAdditionalMutationRunning = useIsAdditionalFormMutationRunning({
    resource,
    action: action,
    tab,
  });

  return (
    isLoading ||
    isAdditionalMutationRunning ||
    isUpdating ||
    isRefetching ||
    isDeleting ||
    isCopying ||
    isCreating
  );
};
